import React from "react";
import styled from "@emotion/styled";
import MemberMonthlyChart from "./Charts/MemberMonthlyChart";

const SelectedMemberChart = ({selectedMemberMonthlyStats, selectedMemberFirstName}) => {

  return (
    <ChartSurface>
      <ChartHeader>
        <div>
          <SectionEyebrow>Monthly Analysis</SectionEyebrow>
          <SectionTitle>{selectedMemberFirstName}'s Monthly Stats</SectionTitle>
        </div>
        <SectionSummary>
          Gross profit and closed investigation outcomes by reporting month.
        </SectionSummary>
      </ChartHeader>
      <ChartRegion>
        <MemberMonthlyChart selectedMemberMonthlyStats={selectedMemberMonthlyStats} />
      </ChartRegion>
    </ChartSurface>
  )
}

const ChartSurface = styled.section(({ theme }) => `
  min-width: 0;
  min-height: 0;
  display: grid;
  grid-template-rows: auto minmax(22rem, 1fr);
  overflow: hidden;
  border: 0.1rem solid ${theme.palette.common.grayBorder};
  border-radius: 0.8rem;
  background: ${theme.palette.common.white};
  box-shadow: 0 0.25rem 0.9rem rgba(15, 23, 42, 0.05);
`)

const ChartHeader = styled.header(({ theme }) => `
  min-width: 0;
  display: grid;
  grid-template-columns: minmax(0, 1fr) auto;
  gap: 1rem;
  align-items: end;
  padding: 0.95rem 1.05rem;
  border-bottom: 0.1rem solid ${theme.palette.common.grayBorder};
  background: ${theme.palette.common.grayBorderLight};
`)

const SectionEyebrow = styled.div(({ theme }) => `
  margin-bottom: 0.18rem;
  color: ${theme.palette.primary.main};
  font-size: 0.72rem;
  font-weight: 800;
  letter-spacing: 0.04rem;
  line-height: 1.2;
  text-transform: uppercase;
`)

const SectionTitle = styled.h2(({ theme }) => `
  margin: 0;
  color: ${theme.palette.common.black};
  font-size: 1.08rem;
  font-weight: 850;
  line-height: 1.2;
`)

const SectionSummary = styled.p(({ theme }) => `
  max-width: 25rem;
  margin: 0;
  color: ${theme.palette.common.grayText};
  font-size: 0.82rem;
  font-weight: 650;
  line-height: 1.35;
  text-align: right;
`)

const ChartRegion = styled.div(({ theme }) => `
  min-width: 0;
  min-height: 0;
  height: 100%;
  padding: 1rem 1rem 0.85rem;
  background: ${theme.palette.common.white};
`)

export default SelectedMemberChart
